// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

export function sedsClear(): ReducerAction {
	return {
		type: Types.SEDS_CLEAR,
		payload: null,
	};
}
